module.exports = __webpack_public_path__ + "img/aeroland-app-showcase-image-02.d46247c9.png";